module.exports = __webpack_public_path__ + "img/banner3.6650b2dc.jpg";